import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpStatusCode } from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable, tap } from "rxjs";
import { MessageService } from "primeng/api";
import { LoadingPanelService,AlertService } from "../services";
import {AlertIcon, TypeChecker} from "../shared";

export function errorInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
    const messageService = inject(MessageService);
    const lps = inject(LoadingPanelService);
    const alertService = inject(AlertService);
    const logFormat = 'background: maroon; color: white';
    return next(req).pipe(
        tap({
            next: event => {
            },
            error: error => {
                lps.hide();
                if (error instanceof HttpErrorResponse && !req.headers.has('skip-error')) {
                    if (error.error) {

                        let parsedError = {} as any;
                        if(typeof error.error === 'string'){
                            parsedError = JSON.parse(error.error)
                        }else if(TypeChecker.hasProperty(error.error, 'error') && TypeChecker.hasProperty(error.error, 'message')){
                            parsedError = error.error;
                        }
                        //revisa la bandera de visible
                        if(TypeChecker.hasProperty(parsedError, 'visible') && parsedError.visible === false){
                            return;
                        }

                        if(parsedError.error && parsedError.message){
                            console.error(parsedError.error + ' - ' + parsedError.message);
                            messageService.add({ severity: 'error', summary: parsedError.error, detail: parsedError.message });
                        }else{
                            console.error(error.name + ' - ' + error.message);
                            messageService.add({ severity: 'error', summary: error.name, detail: error.message });
                        }
                    }else {
                      console.error('HTTP Error -' + error.message);
                      messageService.add({ severity: 'error', summary: "HTTP Error", detail: error.message });
                    }
                    return;
                }
                switch (error.status) {
                    case HttpStatusCode.BadRequest:
                        alertService.show({
                            title: 'Atención',
                            text: 'Ha ocurrido un error al hacer la petición, intente más tarde',
                            icon: AlertIcon.WARN
                        });
                        console.error('%c Bad Request 400', logFormat);
                        break;
                    case HttpStatusCode.Unauthorized:
                       console.error('%c Unauthorized 401', logFormat);
                        break;
                    case HttpStatusCode.NotFound:
                        console.error('%c Not Found 404', logFormat);
                        break;
                    case HttpStatusCode.RequestTimeout:
                        console.error('%c TimeOut 408', logFormat);
                        break;
                    case HttpStatusCode.Forbidden:
                        console.error('%c Forbidden 403', logFormat);
                        break;
                    case HttpStatusCode.InternalServerError:
                        console.error('%c Internal Server Error 500', logFormat);
                        break;
                    default:
                        alertService.show({
                            title: 'Atención',
                            text: 'Sr. Usuario no puede acceder correctamente a este sitio web, consulte con su proveedor de red o intente con otra conexión',
                            icon: AlertIcon.WARN
                        });
                        console.error('%c Unknown Request ', logFormat);
                        break;
                }
            }
        })
    );
}
